export default "__VITE_ASSET__84MbNCHm__"